export default{
    logoURLs: {
        portalLogoURL: null,
        emailLogoURL: null,
        soloSignupLogoURL: null
    },
    themeId: null,
    darkModeData: {},
}